import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { baseOffersAndBookingsReducer, baseOffersAndBookingsEffects } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('offersAndBookings', baseOffersAndBookingsReducer.BaseOffersAndBookingsReducer),
    EffectsModule.forFeature([baseOffersAndBookingsEffects.BaseOffersAndBookingsEffects]),
  ],
})
export class BaseOffersAndBookingsStoreModule {}
